import { useEffect, useState } from "react";
import { saveConsent, loadConsent } from "../utils/consent";

export default function ConsentBanner() {
  const [show, setShow] = useState(false);
  const [showManage, setShowManage] = useState(false);

  useEffect(() => {
    const saved = loadConsent();
    if (!saved) setShow(true);
  }, []);

  const giveConsent = () => {
    const choice = {
      ad_storage: "granted",
      analytics_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    };

    saveConsent(choice);
    window.gtag("consent", "update", choice);
    setShow(false);
  };

  return (
    <>
      {show && (
        <div style={styles.banner}>
          <p>
            We use cookies to improve your experience and show personalized ads.
            Click **Consent** to accept or **Manage** to review your choices.
          </p>

          <button onClick={giveConsent} style={styles.btnPrimary}>
            Consent
          </button>

          <button onClick={() => setShowManage(true)} style={styles.btnSecondary}>
            Manage options
          </button>
        </div>
      )}

      {showManage && (
        <div style={styles.manage}>
          <h3>Manage your privacy settings</h3>
          <p>Select which types of data you allow:</p>
          <button onClick={giveConsent}>Allow all</button>
          <button onClick={() => setShowManage(false)}>Close</button>
        </div>
      )}
    </>
  );
}

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    padding: "20px",
    background: "#fff",
    boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
    display: "flex",
    gap: "12px",
    flexDirection: "column",
    zIndex: 9999,
  },
  btnPrimary: {
    padding: "10px",
    background: "#1976d2",
    color: "#fff",
    border: 0,
    borderRadius: "6px",
    cursor: "pointer",
  },
  btnSecondary: {
    padding: "10px",
    background: "#eee",
    border: 0,
    borderRadius: "6px",
    cursor: "pointer",
  },
};
